import cloneDeep from "lodash/cloneDeep";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setRuleHaveEditting } from "../../../../../actions/common";
import { API_CLIENT_SALES_CONVERSION_DETAIL, API_SALESFORCE_GET_ALL_RULE, TYPE_SHOW_UNSAVE_CHANGE } from "../../../../../constants";
import CenterSpinner from "../../../../general/Loadings/CenterSpinner";
import { callSalesforceApi, callTokenApi } from "../../../../../apiCaller";
import { toastError } from "../../../../../utils";
import { toast } from "react-toastify";

const Step1 = React.lazy(() => import(`./steps/Step1`));
const Step2 = React.lazy(() => import(`./steps/Step2`));

export const SaleConversionDetailContext = React.createContext({});

const DEFAULT_DATA_SALE_CONVERSION = {
     name: "",
     description: "",
     externalId: "",
     conditions: {
          slug: "",
          ssTriggerId: "",
          type: "",
          value: "",
          currency: "",
          isManual: false,
          conversionValue: false,
          primaryObject: '',
          secondaryObject: []
     },
};
const SaleConversionDetail = ({ id }) => {
     const dispatch = useDispatch();
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const accountId = activeAccount.id;
     const [isLoading, setIsLoading] = useState(true);
     const [activeStep, setActiveStep] = useState(1);
     const [stepsData, setStepsData] = useState(cloneDeep(DEFAULT_DATA_SALE_CONVERSION));
     const [initStepsData, setInitStepsData] = useState(cloneDeep(DEFAULT_DATA_SALE_CONVERSION));
     const [listRuleSaleForce, setListRuleSaleForce] = useState({});

     // fetch ss trigger custom object
     const fetchSaleForceAllRule = () => {
          const request = API_SALESFORCE_GET_ALL_RULE.replace(':accountId', accountId);

          setIsLoading(true);
          callSalesforceApi(request, 'GET').then((response) => {
               setIsLoading(false);

               if (response?.status === 200) {
                    const { data } = response.data;
                    setListRuleSaleForce(data);
               } else {
                    toast.error('Get data failed!');
               }
          });
     };

     useEffect(fetchSaleForceAllRule, []); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchSaleConversionDetail = () => {
          if (!id) {
               setIsLoading(false);
               return
          };
          setIsLoading(true);
          callTokenApi(API_CLIENT_SALES_CONVERSION_DETAIL.replace(':accountId', accountId).replace(':id', id), 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         const { conversion } = response.data;
                         setStepsData(conversion);
                         setInitStepsData(conversion);
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    setIsLoading(false);
               });
     };
     useEffect(fetchSaleConversionDetail, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleHasChange = () => {
          dispatch(setRuleHaveEditting({ show: true, type: TYPE_SHOW_UNSAVE_CHANGE.EDIT_SIMPLE }));
     };
     
     return (
          <React.Suspense fallback={<CenterSpinner />}>
               <div className='rule-detail segment-detail'>
                    {isLoading ? (
                         <CenterSpinner />
                    ) : (
                         <div className='cvr-create-new'>
                              <h1>{id ? `Edit Sale Conversion: ${stepsData.name}` : `Create a Sale Conversion`}</h1>
                              <p>
                                   {id
                                        ? "Use the steps below to configure your Sale Conversion."
                                        : "Create your Sale Conversion by following the steps below. "}{" "}
                              </p>
                              <SaleConversionDetailContext.Provider
                                   value={{
                                        id,
                                        activeStep,
                                        setActiveStep,
                                        initStepsData,
                                        setInitStepsData,
                                        stepsData,
                                        setStepsData,
                                        handleHasChange,
                                        listRuleSaleForce,
                                        isLoading
                                   }}
                              >
                                   <Step1 />
                                   <Step2 />
                              </SaleConversionDetailContext.Provider>
                         </div>
                    )}
               </div>
          </React.Suspense>
     );
};

export default SaleConversionDetail;
